module.exports = __webpack_public_path__ + "img/avatar2.1ea590ef.png";